import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";



function OrderDetails() {
  const location = useLocation()
  const [order, setOrder ] = useState({})/* 
  const [ items, setItems ]=useState([]) */
  useEffect(()=>{
    const order = location.state
    setOrder(order.cargo)/* 
    setItems(order.items) */
    console.log(order.cargo);
  },[location.state])

  return (
    <div className="px-5 mb-14">
      <ol className="relative border-l border-gray-200 dark:border-slate-700 py-2">

        { order.payment ?
        <p className="text-lg font-bold text-emerald-700">&nbsp; Order has been Received</p>
        :
        <p className="text-lg font-bold text-red-700">&nbsp; Order has been Cancelled</p>
        }
        { order.payment ?
        <p className="text-md font-bold text-emerald-700">&nbsp; by {order.total}&pi;</p>
        :
        <p className="text-md font-bold text-red-700">&nbsp; not received {order.total}&pi;</p>
        }

        { 
          order.items?.length > 0 && (order.items.map((item)=>(
        <li className="mb-10 ml-4 pt-3">
          <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
          <time className="mb-1 text-sm font-normal leading-none text-gray-400 dark:text-gray-500">
            {order.time}
          </time>
          <h3 className="text-lg font-semibold text-gray-700 ">
            {item.title}
          </h3>
          <img src={item.image} alt="product-display" className="my-3 md:w-80 rounded-lg"/>
          <p className="mb-4 text-base font-normal text-slate-600 ">
            { order.payment ? "Arriving soon" : "Cancelled"}
          </p>
          <p className="mb-4 text-base font-normal text-slate-600 ">
           Quantity: { item.quantity }
          </p>
          <p className="mb-4 text-base font-normal text-slate-600 ">
           Price: { item.price }
          </p>
          <p className="mb-4 text-base font-normal text-slate-600 ">
           Product ID: { item.productId }
          </p>
          <Link
            to={'/orders'}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-gray-200 focus:text-blue-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-700"
          >
            Back{" "}
            <svg
              className="w-3 h-3 ml-2"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </Link>
        </li>
        )) )}

      </ol>
    </div>
  );
}

export default OrderDetails;
